import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/api";

export function StatsCards({ stats }) {
  const items = [
    ["Products", stats.products, "admin-stat-products"],
    ["Orders", stats.orders, "admin-stat-orders"],
    ["Revenue", formatCurrency(stats.revenue), "admin-stat-revenue"],
    ["Open", stats.pending, "admin-stat-pending"],
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-testid="admin-stats-grid">
      {items.map(([label, value, testId]) => (
        <Card key={label} className="rounded-none border-white/10 bg-white/[0.03] text-foreground">
          <CardHeader className="pb-2">
            <CardTitle className="text-xs uppercase tracking-[0.24em] text-zinc-500">{label}</CardTitle>
          </CardHeader>
          <CardContent>
            <p data-testid={testId} className="font-heading text-4xl font-black italic text-volt">{value ?? 0}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
